
import { useState, useEffect } from "react";
import { apiFetch } from "@/lib/api-client";
import type { GetLearnerCourseResponse } from "@/dto/index";

export type PDFMaterial = {
  id: string;
  display_name_et: string;
  s3_object_key: string;
};

export type LearnerCourseData = {
  id: string;
  title: string;
  video_id: string;
  lesson_id: string;
  pdf_materials: PDFMaterial[];
  is_completed: boolean;
  short_description?: string;
  description?: string;
};

export const useLearnerCourse = (courseId: string | undefined) => {
  const [courseData, setCourseData] = useState<LearnerCourseData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!courseId) {
      setLoading(false);
      return;
    }

    const fetchLearnerCourse = async () => {
      console.log("Fetching learner course data for courseId:", courseId);
      
      try {
        setLoading(true);
        setError(null);
        
        const data = await apiFetch<GetLearnerCourseResponse>(`/api/learner/course/${courseId}`);
        console.log("Fetched learner course data:", data);
        
        setCourseData({
          ...data,
          short_description: data.short_description || "",
          description: data.description || ""
        });
      } catch (e: any) {
        console.error("Error in fetchLearnerCourse:", e);
        setError(e.message || "Failed to fetch course data");
      } finally {
        setLoading(false);
      }
    };

    fetchLearnerCourse();
  }, [courseId]);

  const handleCourseCompletion = () => {
    if (courseData) {
      setCourseData({
        ...courseData,
        is_completed: true
      });
    }
  };

  return { courseData, loading, error, handleCourseCompletion };
};
